import {createAction} from '@reduxjs/toolkit';

export const setActiveCollectionId = createAction(
  'featureCollections/setActiveCollectionId',
);

export const setActiveCollection = createAction(
  'featureCollections/setActiveCollection',
);

export const setActiveFeature = createAction(
  'featureCollections/setActiveFeature',
);
